export const ActionTypes = {
  FETCH_JOB_OPERATORS_OPERATION: 'services/jobOperatorsOperation/fetch_job_operators_operation',
  SET_JOB_OPERATORS_OPERATION: 'services/jobOperatorsOperation/set_job_operators_operation',
  SET_JOB_OPERATORS_OPERATION_LOADER_STATUS: 'services/jobOperatorsOperation/set_job_operators_operation_loader_status',
  ADD_UPDATE_JOB_OPERATOR_OPERATION: 'services/jobOperatorsOperation/add_update_jobOperator_operation',
  DELETE_JOB_OPERATOR_OPERATION: 'services/jobOperatorsOperation/delete_jobOperator_operation',
};

const fetchJobOperatorsOperation = ({ jobOperatorsOperationParams }) => ({
  jobOperatorsOperationParams,
  type: ActionTypes.FETCH_JOB_OPERATORS_OPERATION,
});

const setJobOperatorsOperation = ({ jobOperatorsOperationData }) => ({
  jobOperatorsOperationData,
  type: ActionTypes.SET_JOB_OPERATORS_OPERATION,
});

const setJobOperatorsOperationLoaderStatus = ({ jobOperatorOperationsLoader }) => ({
  jobOperatorOperationsLoader,
  type: ActionTypes.SET_JOB_OPERATORS_OPERATION_LOADER_STATUS,
});

const addUpdateJobOperatorsOperation = ({ actionName, jobOperatorsOperationObj, jobOperatorsOperationParams }) => ({
  actionName,
  jobOperatorsOperationObj,
  jobOperatorsOperationParams,
  type: ActionTypes.ADD_UPDATE_JOB_OPERATOR_OPERATION,
});

const deleteJobOperatorsOperation = ({ jobOperatorsId, jobOperatorsOperationParams }) => ({
  jobOperatorsId,
  jobOperatorsOperationParams,
  type: ActionTypes.DELETE_JOB_OPERATOR_OPERATION,
});

export default {
  fetchJobOperatorsOperation,
  setJobOperatorsOperation,
  setJobOperatorsOperationLoaderStatus,
  addUpdateJobOperatorsOperation,
  deleteJobOperatorsOperation,
};
